import React from "react";
import { Label } from "../input";

//type EyePositionHeadingProps = { right_label_for: string, left_label_for: string};

const EyePositionHeading = () => (
  <div className="mdc-layout-grid__inner">
    <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-3"></div>
    <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
      <h4>Right eye</h4>
    </div>

    <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
      <h4>Left eye</h4>
    </div>
  </div>
);

export default EyePositionHeading;
